module.exports = __webpack_public_path__ + "img/vue2-renfort_rouge.a46d35d9.png";